import React from 'react';
import PropTypes from 'prop-types';

import { pure } from '@dbk/ui-react-utils';
import { AbbreviatedNumber } from '../../../common/number';
import Text from '../../../common/text';
import { NO_DATA } from '../../../../constants';
import { injectIntl } from 'react-intl';

function AssetItemDataText(props) {
  const { value } = props;

  if (value === null || value === undefined) {
    return (
      <div aria-label={props.intl.messages['app.common.nullValue']}>
        <Text>{NO_DATA}</Text>
      </div>
    )
  }


  if (typeof value !== 'number') {
    return null;
  }
  return (
    <AbbreviatedNumber
      renderProps={{ size: 'large' }}
      renderExactAs="currency"
      maxDigits={8}
      value={value}
    />
  );
}

AssetItemDataText.propTypes = {
  value: PropTypes.number,
};

AssetItemDataText.contextTypes = {
  intl: PropTypes.object,
};

export default pure(injectIntl(AssetItemDataText));
